/* globals Class, lp, jui */
var _                   = require('lodash');
var jQuery              = require('jquery');

var ubBanzai            = require('ub/control/banzai-features');
var LightboxSizeControl = require('ub/ui/lightbox-size-control');
var FontPickerInstaller = require('ub/fonts/font-picker/form/installation-helper').default;
var formFieldColumnControl = require('ub/ui/properties-panel/forms/form-field-columns-control').default;
var formOptionGroupColumnControl = require('ub/ui/properties-panel/forms/form-option-group-columns-control').default;

module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.editor.panel.ElementBackgroundControlsOld,
  lp.editor.panel.ElementBorderControls,
  lp.ModuleComponent,
  {
    type:'lp-pom-form',

    initialize: function($super) {
      $super(this);
      var self = this;

      this.modelChangeHandlers.push(function(e) {
        /* jshint maxcomplexity:37 */
        var accessor = e.data.accessor;
        var value = e.data.value;
        var m = e.source;

        switch(accessor) {
        case 'geometry.offset':
          break;
        case 'geometry.buttonPlacement':
          self.controls.buttonPlacement.setValue(e.data.value === 'auto');
          break;
        case 'content.confirmAction':
          self.controls.confirmAction.setSelectedValue(value);
          self.showConfirmInputs(value);
          break;
        case 'content.confirmURL':
          self.controls.confirmURL.setValue({url:(value ? value : ''), target:''});
          break;
        case 'content.passParams':
          self._setPassParamsControlValue();
          break;
        case 'content.passParamsOnPost':
          self._setPassParamsControlValue();
          break;
        case 'content.confirmMessage':
          self.controls.confirmMessage.setValue(value ? value : 'Thank you!');
          break;
        case 'geometry.label.alignment':
          self.controls.alignSelect.setSelectedValue(value === 'right' ? 'left' : value);
          break;
        case 'geometry.label':
          self.controls.alignSelect.setSelectedValue(m.get('geometry.label.alignment'));
          break;
        case 'style.label.font.family':
        case 'style.label.font.weight':
          FontPickerInstaller.setDefaultFont(self, m, 'label');
          break;
        case 'style.label.color':
          self.controls.labelColor.setValue(value ? value : '');
          break;
        case 'style.label.font.size':
          self.controls.labelFontSize.setValue(value ? value * 1 : 0);
          break;
        case 'geometry.field.height':
          self.controls.fieldHeight.setValue(value ? value * 1 : 0);
          break;
        case 'geometry.field.fontSize':
          self.controls.fieldFontSize.setValue(value ? value * 1 : 12);
          break;
        case 'geometry.field.margin.bottom':
          self.controls.fieldSpacing.setValue(value ? value * 1 : 0);
          break;
        case 'style.field.backgroundColor':
          self.controls.fieldBkgColor.setValue(value ? value : 'fff');
          break;
        case 'style.field.color':
          self.controls.fieldColor.setValue(value ? value : '000');
          break;
        case 'geometry.field.border':
          self.controls.fieldBorder.setValue(value ? value : {width:1, style:'solid', color: this.getModule().getElementDefaults().geometry.field.border.color});
          break;
        case 'style.cbxlabel.font.size':
          self.controls.cbxLabelFontSize.setValue(value ? value * 1 : 0);
          break;
        case 'style.cbxlabel.font.family':
        case 'style.cbxlabel.font.weight':
          FontPickerInstaller.setDefaultFont(self, m, 'cbxlabel');
          break;
        case 'style.cbxlabel.color':
          self.controls.cbxLabelColor.setValue(value ? value : '');
          break;
        default:
          // reset all properties panel controls
          self.setElement(self.element);
        }
      });
    },

    startEditingFields: function() {
      this.getModule().openBuilder(this.element, {
        callback: this.element.updateContentFields.bind(this.element)
      });
    },

    _getConfirmActionOpts: function(selectOptions) {
      var confirmActionOpts = {
        label             : 'Confirmation',
        id                : 'jui-confirm-action-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down',
        action            : this._mkChangeHandler(this._confirmationUIBinding, 'changeConfirmAction'),
        selectOptions     : selectOptions
      };

      confirmActionOpts.dropDownClassName += ' full-width-dropdown';

      return confirmActionOpts;
    },

    _allowFormColumns: function() {
      return ubBanzai.features.isAllowFormColumnsEnabled() && window.editor.page.getConfigValue('allowFormColumns');
    },

    installFormOptionGroupColumnControls: function(cbxAttrsPanel, panel) {
      if (panel._allowFormColumns()) {
        formOptionGroupColumnControl.installFormColumnControls(cbxAttrsPanel, panel);
      }
    },

    installFormFieldColumnControls: function(fieldAttrsPanel, panel) {
      if (panel._allowFormColumns()) {
        formFieldColumnControl.installFormColumnControls(fieldAttrsPanel, panel);
      }
    },

    installUI: function($super){
      /* jshint maxstatements:48 */
      // TODO: gut this! Test and Refactor
      $super();

      var self  = this;
      var ctrls = this.controls;

      var formFields = this.insert(new jui.CollapsiblePanel({
        title:'Form Fields',
        attributes: {
          className: 'collapsible-panel panel-form-edit no-label'
        }
      }));
      // TODO-TR: clean this up and move the styles out to css
      // the left/right padding is a bit off
      formFields.e.style.borderTop = 'none';
      formFields.titleBar.hide();

      this._builderUIBinding = this._uiBinding.mkNamespacedVersion('builder');

      this._builderUIBinding
        .filterByEventType('startEditingFields')
        .subscribe(this.startEditingFields.bind(this));

      formFields.insertContent(new jui.Button({
        label:  'Edit Form Fields',
        id:     'edit-form-fields-button',
        action: function() {
          self._builderUIBinding.onNext({
            type:      'startEditingFields',
            elementId: self.element.id
          });
        },
        classNames: ['full-width-button']
      }));

      var geometryPanel = this.insert(new jui.CollapsiblePanel({
        title:'Geometry',
        attributes: {
          className: 'form-element-panel collapsible-panel panel-form-geometry'
        }
      }));

      this._confirmationUIBinding = this._uiBinding
        .mkNamespacedVersion('confirmation')
        .subscribeDomainEvents(this.confirmationDomainEvents, this);
      var confirmationPanel = this.insert(new jui.CollapsiblePanel({
        title:'Form Confirmation',
        attributes: {
          className: 'collapsible-panel panel-form-confirmation labels-above'
        }
      }));

      this._labelUIBinding = this._uiBinding
        .mkNamespacedVersion('label')
        .subscribeDomainEvents(this.labelDomainEvents, this);
      var labelAttrsPanel  = this.insert(new jui.CollapsiblePanel({
        title:'Label Attributes',
        attributes: {
          className: 'collapsible-panel panel-form-label'
        }
      }));

      FontPickerInstaller.installFieldLabelFontPicker(this, labelAttrsPanel);

      this._installFieldsPanel();

      this._checkboxUIBinding = this._uiBinding
        .mkNamespacedVersion('checkbox')
        .subscribeDomainEvents(this.checkboxDomainEvents, this);
      var cbxAttrsPanel = this.insert(new jui.CollapsiblePanel({
        title:'Checkbox/Radio Button',
        attributes: {
          className: 'collapsible-panel panel-form-check-radio'
        }
      }));

      FontPickerInstaller.installCheckboxFontPicker(this, cbxAttrsPanel);

      this._buttonUIBinding = this._uiBinding
        .mkNamespacedVersion('button')
        .subscribeDomainEvents(this.buttonDomainEvents, this);
      var buttonPanel = this.insert(new jui.CollapsiblePanel({
        title:'Button Settings',
        attributes: {
          className: 'collapsible-panel panel-form-button'
        }
      }));

      ctrls.applyLabelDefaults = labelAttrsPanel.titleBar.insert(new jui.Button({
        label  : 'Reset Style',
        id     : 'use-label-defaults-button',
        attributes: {
          className: 'button link'
        },
        action : this._mkChangeHandler(self._labelUIBinding, 'setToElementDefaults')
      }));

      ctrls.applyCheckboxDefaults = cbxAttrsPanel.titleBar.insert(new jui.Button({
        label  : 'Reset Style',
        id     : 'use-checkbox-defaults-button',
        attributes: {
          className: 'button link'
        },
        action : this._mkChangeHandler(self._checkboxUIBinding, 'setToElementDefaults')
      }));

      var selectOptions = [
        {name: 'Show form confirmation dialog', value: 'modal'},
        {name: 'Go to URL',                     value: 'url'},
        {name: 'Post form data to a URL',       value: 'post'},
        {name: 'Show alert message',            value: 'message'}
      ];

      if (window.editor.mainPage.allowExternalLightboxes()) {
        selectOptions.push({name: 'Open URL in lightbox', value: 'externalLightbox'});
      }

      ctrls.confirmAction = confirmationPanel.insertContent(
        new jui.FormSelect(this._getConfirmActionOpts(selectOptions))
      );

      ctrls.confirmURL = confirmationPanel.insertContent(new jui.FormLinkInput2({
        label          : 'URL',
        lightbox       : window.editor.mainPage.allowExternalLightboxes(),
        hideTarget     : false,
        elmType        : 'lp-pom-form',
        onblur         : this._mkChangeHandler(self._confirmationUIBinding, 'changeURL'),
        onfocus        : this.requestFocus.bind(this)
      }));

      // TODO: remove this separate control and use FormLinkInput2's passparams instead
      ctrls.passParams = confirmationPanel.insertContent(new jui.FormCheckboxInput({
        label   : 'Append form data to URL',
        inputId : 'pass-params-checkbox',
        onclick : this._mkChangeHandler(self._confirmationUIBinding, 'changeAppendFormData')
      }));

      ctrls.externalLightboxSize = confirmationPanel.insertContent(new LightboxSizeControl({
        onblur  : self._mkChangeHandler(self._confirmationUIBinding, 'changeExternalLightboxSize'),
        onfocus : self.requestFocus.bind(this)
      }).hide());

      ctrls.confirmMessage = confirmationPanel.insertContent(new jui.FormTextArea({
        label         : 'Message Text',
        inputPosition : 'clear-label',
        onblur        : this._mkChangeHandler(self._confirmationUIBinding, 'changeMessage'),
        onfocus       : function(e) { self.requestFocus(e); }
      }));

      ctrls.editFormConfirmation = confirmationPanel.insertContent(new jui.Button({
        label      : 'Edit Confirmation Dialog',
        action     : this._mkChangeHandler(self._confirmationUIBinding, 'editConfirmationDialog'),
        classNames : ['full-width-button']
      }));

      ctrls.editFormConfirmation.hide();

      ctrls.alignSelect = labelAttrsPanel.insertContent(new jui.FormSelect({
        label             : 'Alignment',
        id                : 'jui-label-align-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down',
        selectOptions     : [{name:'Top', value:'top'}, {name:'Left', value:'left'}],
        action            : this._mkChangeHandler(self._labelUIBinding, 'changeAlign')
      }));

      ctrls.labelColor = labelAttrsPanel.insertContent(new jui.FormColorInput({
        label   : 'Color',
        onblur  : this._mkChangeHandler(self._labelUIBinding, 'changeColor'),
        onfocus : function(e) { self.requestFocus(e); }
      }));

      ctrls.labelFontSize = labelAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Font Size',
        onchange      : this._mkChangeHandler(self._labelUIBinding, 'changeFontSize'),
        onfocus       : function(e) { self.requestFocus(e); },
        startTracking : function() {
          var m = self.element.model;
          var um = self.element.page.undoManager;
          um.registerUndo({
            action   : m.set,
            receiver : m,
            params   : ['style.label.font.size', m.get('style.label.font.size'), um]
          });
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 10,
          max: 48,
          increment: 1
        }
      }));

      ctrls.labelWidth = labelAttrsPanel.insertContent(new jui.FormSizeInput({
        label        : 'Label Width',
        labelW       : 'W',
        hideHeight   : true,
        hideMiniLabel: true,
        onblur       : this._mkChangeHandler(self._labelUIBinding, 'changeWidth'),
        onfocus      : function(e) {self.requestFocus(e);}
      }));

      ctrls.labelAutoWidth = ctrls.labelWidth.insert(new jui.FormCheckboxInput({
        label   : 'Auto',
        inputId : 'label-auto-width-checkbox',
        onclick : this._mkChangeHandler(self._labelUIBinding, 'changeWidthAuto')
      }));

      ctrls.labelWidth.hide();

      ctrls.cbxLabelColor = cbxAttrsPanel.insertContent(new jui.FormColorInput({
        label   : 'Color',
        onblur  : this._mkChangeHandler(self._checkboxUIBinding, 'changeTextColor'),
        onfocus : function(e) { self.requestFocus(e); }
      }));

      ctrls.cbxLabelFontSize = cbxAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Font Size',
        onchange      : this._mkChangeHandler(self._checkboxUIBinding, 'changeFontSize'),
        onfocus       : function(e) { self.requestFocus(e); } ,
        startTracking : function() {
          var m = self.element.model;
          var um = self.element.page.undoManager;
          um.registerUndo({
            action   : m.set,
            receiver : m,
            params   : ['style.cbxlabel.font.size', m.get('style.cbxlabel.font.size'), um]
          });
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 10,
          max: 48,
          increment: 1
        }
      }));

      this.installFormOptionGroupColumnControls(cbxAttrsPanel, this);

      this.installGeometryControls({insert:geometryPanel.insertContent.bind(geometryPanel), sizeOptions:{hideHeight:true}});

      ctrls.buttonPlacement = buttonPanel.insertContent(new jui.FormCheckboxInput({
        label   : 'Auto position submit button',
        inputId : 'button-placement-checkbox',
        onclick : this._mkChangeHandler(self._buttonUIBinding, 'changePlacement')
      }));
    },

    _installFieldsPanel: function() {
      var self = this;
      var ctrls = this.controls;
      var fieldAttrsPanel  = this.insert(new jui.CollapsiblePanel({
        title:'Field Attributes',
        attributes: {
          className: 'collapsible-panel panel-form-attributes'
        }
      }));

      this._fieldUIBinding = this._uiBinding
        .mkNamespacedVersion('field')
        .subscribeDomainEvents(this.fieldDomainEvents, this);

      ctrls.applyFieldDefaults = fieldAttrsPanel.titleBar.insert(new jui.Button({
        label  : 'Reset Style',
        id     : 'use-field-defaults-button',
        attributes: {
          className: 'button link'
        },
        action : this._mkChangeHandler(self._fieldUIBinding, 'setToElementDefaults')
      }));

      this.installFormFieldColumnControls(fieldAttrsPanel, this);

      ctrls.fieldHeight = fieldAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Height',
        onchange      : this._mkChangeHandler(self._fieldUIBinding, 'changeHeight'),
        onfocus       : function(e) { self.requestFocus(e); } ,
        startTracking : function() {
          var m  = self.element.model;
          var um = self.element.page.undoManager;
          um.startGroup();

          um.registerUndo({
            action   : m.set,
            receiver : m,
            params   : ['geometry.field.height', m.get('geometry.field.height'), um]
          });

          um.registerUndo({
            action   : m.set,
            receiver : m,
            params   : ['geometry.field.fontSize', m.get('geometry.field.fontSize'), um]
          });

          um.endGroup();
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 15,
          max: 48,
          increment: 1
        }
      }));

      ctrls.fieldSpacing = fieldAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Spacing',
        onchange      : this._mkChangeHandler(self._fieldUIBinding, 'changeSpacing'),
        onfocus       : function(e) { self.requestFocus(e); },
        startTracking : function() {
          var m = self.element.model;
          var um = self.element.page.undoManager;
          um.registerUndo({
            action:m.set,
            receiver:m,
            params: ['geometry.field.margin.bottom', m.get('geometry.field.margin.bottom'), um]
          });
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 10,
          max: 48,
          increment: 1
        }
      }));

      ctrls.fieldFontSize = fieldAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Font Size',
        onchange      : this._mkChangeHandler(self._fieldUIBinding, 'changeFontSize'),
        onfocus       : function(e) { self.requestFocus(e); },
        startTracking : function() {
          var m = self.element.model;
          var um = self.element.page.undoManager;
          um.registerUndo({
            action:m.set,
            receiver:m,
            params: ['geometry.field.fontSize', m.get('geometry.field.fontSize'), um]
          });
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 10,
          max: 37,
          increment: 1
        }
      }));

      ctrls.fieldBorder = fieldAttrsPanel.insertContent(new jui.FormBorderInput({
        styleSelectOptions:[
          {name:'None',   value:'none'},
          {name:'Solid',  value:'solid'},
          {name:'Dotted', value:'dotted'},
          {name:'Dashed', value:'dashed'},
          {name:'Inset',  value:'inset'},
          {name:'Outset', value:'outset'}],
        label   : 'Border',
        onblur  : this._mkChangeHandler(self._fieldUIBinding, 'changeBorder'),
        onfocus : function(e) { self.requestFocus(e); }
      }));

      ctrls.cornerRadius = fieldAttrsPanel.insertContent(new jui.FormSliderInput({
        label         : 'Corner Radius',
        onchange      : this._mkChangeHandler(self._fieldUIBinding, 'changeCornerRadius'),
        onfocus       : function(e) {self.requestFocus(e);} ,
        startTracking : function() {
          var m = self.element.model;
          var um = self.element.page.undoManager;
          um.registerUndo({
            action   : m.set,
            receiver : m,
            params   : ['geometry.field.cornerRadius', m.exists('geometry.field.cornerRadius') ? m.get('geometry.field.cornerRadius') : 0, um]
          });
          self.showSamples();
        },
        stopTracking: function() { self.hideSamples(); },
        slider: {
          min: 0,
          max: 20,
          increment: 1
        }
      }));

      ctrls.fieldBkgColor = fieldAttrsPanel.insertContent(new jui.FormColorInput({
        label   : 'Background',
        onblur  : this._mkChangeHandler(self._fieldUIBinding, 'changeBackgroundColor'),
        onfocus : function(e) { self.requestFocus(e); }
      }));

      ctrls.innerShadow = fieldAttrsPanel.insertContent(new jui.FormCheckboxInput({
        label   : 'Show inner shadow',
        inputId : 'inner-shadow-checkbox',
        onclick : this._mkChangeHandler(self._fieldUIBinding, 'changeInnerShadow')
      }));

      ctrls.fieldColor = fieldAttrsPanel.insertContent(new jui.FormColorInput({
        label   : 'Text Color',
        onblur  : this._mkChangeHandler(self._fieldUIBinding, 'changeTextColor'),
        onfocus : function(e) { self.requestFocus(e); }
      }));
    },

    _mkChangeHandler: function(uiBinding, eventType) {
      var changeHandler = function(e) {
        var eventParams = { type: eventType };

        if (e.source && _.isFunction(e.source.getValue)) {
          eventParams.value = e.source.getValue();
        }

        if (e.slider) {
          eventParams.sliderTracking = e.slider.tracking;
        }

        uiBinding.onNext(eventParams);
      };

      return changeHandler;
    },

    oldShowSamples: function() {
      this.element.fieldViewMap.each(function(fv) {
        if (fv.field.lpType === 'single-line-text' || fv.field.lpType === 'email') {
          fv.view.root.down('input').value = fv.field.name;
        } else if (fv.field.lpType === 'multi-line-text') {
          fv.view.root.down('textarea').value = 'line one\nline two\nline three\nline four';
        }
      });
    },

    newShowSamples: function() {
      this.element.fieldViewMap.each(function(fieldView) {
        if (_.contains(['single-line-text', 'email'], fieldView.field.lpType)) {
          fieldView.root.down('input').value = fieldView.field.name;
        } else if (fieldView.field.lpType === 'multi-line-text') {
          fieldView.root.down('textarea').value = 'line one\nline two\nline three\nline four';
        }
      });
    },

    showSamples: function() {
      if (this.element.areFormColumnsAllowed()) {
        this.newShowSamples();
      } else {
        this.oldShowSamples();
      }
    },

    oldHideSamples: function() {
      this.element.fieldViewMap.each(function(fv) {
        if (fv.field.lpType === 'single-line-text' || fv.field.lpType === 'email') {
          fv.view.root.down('input').value = '';
        }
      });
    },

    newHideSamples: function() {
      this.element.fieldViewMap.each(function(fieldView) {
        const rootElm = fieldView.root;

        if (_.contains(['single-line-text', 'email'], fieldView.field.lpType)) {
          rootElm.down('input').value = '';
        } else if (fieldView.field.lpType === 'multi-line-text') {
          rootElm.down('textarea').value = '';
        }
      });
    },

    hideSamples: function() {
      if (this.element.areFormColumnsAllowed()) {
        this.newHideSamples();
      } else {
        this.oldHideSamples();
      }
    },

    showConfirmInputs: function(action) {
      this.controls.editFormConfirmation.setVisible(action === 'modal');
      this.controls.confirmMessage.setVisible(action === 'message');
      this.controls.confirmURL.setVisible(this._showConfirmURLField(action));
      this.controls.passParams.setVisible(this._showPassParamsField(action));
      this.controls.externalLightboxSize.setVisible(
        action === 'externalLightbox' && this.element.page.allowExternalLightboxes());
    },

    _showConfirmURLField: function(action) {
      return action === 'url' || action === 'post' || action === 'externalLightbox';
    },

    _showPassParamsField: function(action) {
      var availableOnPost = ubBanzai.features.isDataOnFormPostEnabled() ||
                            this.element.model.safeGet('content.passParamsOnPost');

      var availableOnExternalLightbox = this.element.page.allowExternalLightboxes();

      return action === 'url' ||
        (action === 'post' && availableOnPost) ||
        (action === 'externalLightbox' && availableOnExternalLightbox);
    },

    getMinFontSize: function(fieldHeight) {
      return Math.floor(parseInt(fieldHeight, 10) * 0.75);
    },

    setMinFontSize: function(fontSize, fieldHeight, um) {
      var minFontSize = this.getMinFontSize(fieldHeight);
      if (fontSize > minFontSize) {
        this.controls.fieldFontSize.setValue(minFontSize);
        this.element.model.set('geometry.field.fontSize', minFontSize, um);
      }
    },

    syncUIControls: function($super, elm) {
      /* jshint maxcomplexity:26 */
      $super(elm);

      var m = elm.model;
      var labelAlign = elm.model.get('geometry.label.alignment') === 'right' ? 'left' : elm.model.get('geometry.label.alignment');

      this.bindGeometryControlsToElement(elm);
      this.controls.buttonPlacement.setValue(m.exists('geometry.buttonPlacement') ? m.get('geometry.buttonPlacement') === 'auto' : true);

      formFieldColumnControl.updateFormColumnControls(this);
      formOptionGroupColumnControl.updateFormColumnControls(this);

      this.controls.alignSelect.setSelectedValue(labelAlign);

      FontPickerInstaller.updateLabelFont(this, m);

      this.controls.labelFontSize.setValue(m.exists('style.label.font.size') ? m.get('style.label.font.size') * 1 : 0);
      this.controls.labelColor.setValue(m.exists('style.label.color') ? m.get('style.label.color') : '');
      this.controls.labelWidth.setValue({width:elm.getCalculatedLabelWidth()});
      this.controls.labelAutoWidth.setValue(elm.isAutoCalculateLabelWidth());

      this.controls.labelWidth.setVisible(labelAlign === 'left');

      this.controls.fieldSpacing.setValue(m.exists('geometry.field.margin.bottom') ? m.get('geometry.field.margin.bottom') * 1 : 0);
      this.controls.fieldHeight.setValue(m.exists('geometry.field.height') ? m.get('geometry.field.height') * 1 : 0);
      this.controls.fieldFontSize.setValue(m.exists('geometry.field.fontSize') ? m.get('geometry.field.fontSize') * 1 : 12);
      this.controls.fieldBkgColor.setValue(m.exists('style.field.backgroundColor') ? m.get('style.field.backgroundColor') : 'fff');
      this.controls.fieldColor.setValue(m.exists('style.field.color') ? m.get('style.field.color') : '000');
      this.controls.fieldBorder.setValue(m.exists('geometry.field.border') ? m.get('geometry.field.border') : {width:1, style:'solid', color: this.getModule().getElementDefaults().geometry.field.border.color});
      this.controls.cornerRadius.setValue(m.exists('geometry.field.cornerRadius') ? m.get('geometry.field.cornerRadius') * 1 : 0);

      this.controls.innerShadow.setValue(m.exists('style.field.innerShadow') && m.get('style.field.innerShadow'));

      FontPickerInstaller.updateCheckboxFont(this, m);

      this.controls.cbxLabelFontSize.setValue(m.exists('style.cbxlabel.font.size') ? m.get('style.cbxlabel.font.size') * 1 : 0);
      this.controls.cbxLabelColor.setValue(m.exists('style.cbxlabel.color') ? m.get('style.cbxlabel.color') : '');

      var action = elm.model.safeGet('content.confirmAction') || 'message';
      this.controls.confirmAction.setSelectedValue(action);
      this.showConfirmInputs(action);

      var confirmURLValues = {
        url    : elm.model.safeGet('content.confirmURL') || '',
        target : elm.model.safeGet('content.confirmTarget')
      };

      this.controls.confirmURL.setValue(confirmURLValues);

      if (this.element.page.allowExternalLightboxes()) {
        var lightboxSizeValue = elm.model.safeGet('lightboxSize') ||
          lp.module.form.FormElement.lightboxSizeDefault;
        this.controls.externalLightboxSize.setValue(lightboxSizeValue);
      }

      this.controls.confirmMessage.setValue(elm.model.safeGet('content.confirmMessage') || 'Thank you!');
      this._setPassParamsControlValue();
    },

    _setPassParamsControlValue: function() {
      this.controls.passParams.setValue(this.element.model.getPassParams() || false);
    },

    confirmationDomainEvents: {
      changeConfirmAction: function(ev) {
        var self = this;

        if(ev.value === "externalLightbox") {
          jQuery(window).trigger('externalLightboxSelected');
        }
        this.performModelUpdates(function() {
          self.element.model.set('content.confirmAction', ev.value, self.element.page.undoManager);
          self.showConfirmInputs(ev.value);
        });

        // Sync controls:
        this.controls.confirmAction.setSelectedValue(ev.value);
        this._setPassParamsControlValue();
      },

      editConfirmationDialog: function() {
        window.editor.setActivePage(window.editor.findPagesUsedAs('form_confirmation')[0]);
      },

      changeMessage: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('content.confirmMessage', ev.value, self.element.page.undoManager);
        });
        this.controls.confirmMessage.setValue(ev.value); // Sync control
      },

      changeURL: function(ev) {
        var self = this;

        this.performModelUpdates(function() {
          var undoManager = self.element.page.undoManager;
          undoManager.startGroup();
          self.element.model.set('content.confirmTarget', ev.value.target, undoManager);
          self.element.model.set('content.confirmURL', ev.value.url, undoManager);
          undoManager.endGroup();
        });

        this.controls.confirmURL.setValue(ev.value); // Sync control
      },

      changeAppendFormData: function(ev) {
        var self = this;

        this.performModelUpdates(function() {
          self.element.model.setPassParams(ev.value, self.element.page.undoManager);
        });

        this.controls.passParams.setValue(ev.value); // Sync control
      },

      changeExternalLightboxSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('lightboxSize', ev.value, self.element.page.undoManager);
        });
        this.controls.externalLightboxSize.setValue(ev.value); // Sync control
      }
    },

    labelDomainEvents: {
      setToElementDefaults: function() {
        var m  = this.element.model;
        var um = this.element.page.undoManager;
        um.startGroup();
        m.set('style.label',    jui.clone(this.getModule().getElementDefaults().style.label),    um);
        m.set('geometry.label', jui.clone(this.getModule().getElementDefaults().geometry.label), um);
        um.endGroup();
      },

      changeFont: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          var um = self.element.page.undoManager;
          um.startGroup();
          self.element.model.set('style.label.font.family', ev.value.family, um);
          self.element.model.set('style.label.font.weight', ev.value.weight, um);
          um.endGroup();
        });
      },

      changeAlign: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.setLabelAlignment(ev.value, self.element.getUndoManager());
        });
        this.controls.labelWidth.setValue({width: self.element.getCalculatedLabelWidth()});
        this.controls.labelWidth.setVisible(ev.value === 'left');
        this.controls.alignSelect.setSelectedValue(ev.value); // Sync control
      },

      changeColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.label.color', ev.value, self.element.page.undoManager);
        });
        this.controls.labelColor.setValue(ev.value); // Sync control
      },

      changeFontSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.label.font.size', ev.value, ev.sliderTracking ? null : self.element.page.undoManager);
        });
        this.controls.labelFontSize.setValue(ev.value); // Sync control
      },

      changeWidth: function(ev) {
        this.element.setLabelWidthExplicitly(ev.value.width, this.element.getUndoManager());
      },

      changeWidthAuto: function(ev) {
        this.element.setAutoCalculateLabelWidth(ev.value, this.element.getUndoManager());
      }
    },

    fieldDomainEvents: {
      setToElementDefaults: function() {
        var m  = this.element.model;
        var um = this.element.page.undoManager;
        um.startGroup();
        m.set('geometry.field', jui.clone(this.getModule().getElementDefaults().geometry.field), um);
        m.set('style.field',    jui.clone(this.getModule().getElementDefaults().style.field),    um);
        um.endGroup();
      },

      changeHeight: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          var um = ev.sliderTracking ? null : self.element.page.undoManager;

          if (um) { um.startGroup(); }
          self.element.model.set('geometry.field.height', ev.value, um);
          self.setMinFontSize(self.controls.fieldFontSize.getValue(), ev.value, um);
          if (um) { um.endGroup(); }
        });
        this.controls.fieldHeight.setValue(ev.value); // sync controls
      },

      changeSpacing: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('geometry.field.margin.bottom', ev.value, ev.sliderTracking ? null : self.element.page.undoManager);
        });
        this.controls.fieldSpacing.setValue(ev.value); // sync controls
      },

      changeFontSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          var h = self.controls.fieldHeight.getValue();
          var height = self.getMinFontSize(h);
          if(ev.value > height) {
            self.controls.fieldFontSize.setValue(height);
          } else {
            self.element.model.set('geometry.field.fontSize', Math.min(ev.value, h), ev.sliderTracking ? null : self.element.page.undoManager);
            self.controls.fieldFontSize.setValue(ev.value); // sync controls
          }
        });
      },

      changeBorder: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('geometry.field.border', ev.value, self.element.page.undoManager);
        });

        if ( ! _.isEqual(self.controls.fieldBorder.getValue(), ev.value)) { // jscs:ignore disallowSpacesInsideParentheses
          self.controls.fieldBorder.setValue(ev.value); // sync control
        }
      },

      changeCornerRadius: function(ev) {
        var self = this;
        this.performModelUpdates(function(){
          self.element.model.set('geometry.field.cornerRadius', ev.value, ev.sliderTracking ? null : self.element.page.undoManager);
        });
        this.controls.cornerRadius.setValue(ev.value); // sync control
      },

      changeBackgroundColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.field.backgroundColor', ev.value, self.element.page.undoManager);
        });
        this.controls.fieldBkgColor.setValue(ev.value); // sync controls
      },

      changeTextColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.field.color', ev.value, self.element.page.undoManager);
        });
        this.controls.fieldColor.setValue(ev.value); // sync controls
      },

      changeInnerShadow: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.field.innerShadow', ev.value, self.element.page.undoManager);
        });
        this.controls.innerShadow.setValue(ev.value); // sync controls
      }
    },

    checkboxDomainEvents: {
      setToElementDefaults: function() {
        this.element.model.set('style.cbxlabel', jui.clone(this.getModule().getElementDefaults().style.cbxlabel), this.element.page.undoManager);
      },

      changeFont: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          var um = self.element.page.undoManager;
          um.startGroup();
          self.element.model.set('style.cbxlabel.font.family', ev.value.family, um);
          self.element.model.set('style.cbxlabel.font.weight', ev.value.weight, um);
          um.endGroup();
        });
      },

      changeTextColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.cbxlabel.color', ev.value, self.element.page.undoManager);
        });
        this.controls.cbxLabelColor.setValue(ev.value); // sync controls
      },

      changeFontSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.cbxlabel.font.size', ev.value, ev.sliderTracking ? null : self.element.page.undoManager);
        });
        this.controls.cbxLabelFontSize.setValue(ev.value); // sync controls
      }
    },

    buttonDomainEvents: {
      changePlacement: function(ev) {
        var self = this;

        this.performModelUpdates(function() {
          self.element.setAutoButtonPlacement(ev.value ? 'auto' : 'manual');
        });

        this.controls.buttonPlacement.setValue(ev.value);
      }
    }
  }

);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-form/form_element_properties_panel.js
// module id = 1458
// module chunks = 0